import React from 'react'
import cx from 'classnames'
import classes from 'styles/HeaderBar.module.scss'
import { SignOutButton } from '@/components/signin/SignOutButton'
import Image from 'next/image'
import { Tooltip, Button, Popup } from '@fluentui/react-northstar'
import { useSession } from 'next-auth/react'
import Link from 'next/link'
import { SUPPORT_MAIL } from '@/constantsClient'
import { SafeAvatar } from '@/components/SafeAvatar'
import { useTeamsMobile } from '@/hooks/useTeamsMobile'

interface IHeaderBarProps {
  showLogOutButton?: boolean
  className?: string
}

export const HeaderBar: React.FC<IHeaderBarProps> = ({
  showLogOutButton = true,
  className = '',
}) => {
  const session = useSession()
  const email = session.data?.user?.email
  const image = session.data?.user?.image
  const name = session.data?.user?.name
  const isMobile = useTeamsMobile()

  const handleFeedback = () => {
    window.location.href = '/contact-us'
  }

  const menuItems = (
    <div className={classes.menuContent}>
      <Link href="/app" passHref>
        <Button text fluid content="Dashboard" className={classes.menuItem} />
      </Link>
      {!isMobile && (
        <Link href="/account/subscription" passHref>
          <Button text fluid content="Subscription" className={classes.menuItem} />
        </Link>
      )}
      <Link href="/account/preferences" passHref>
        <Button text fluid content="Preferences" className={classes.menuItem} />
      </Link>
      {/* Show team management only for non-free accounts */}
      {!isMobile && (
        <Link href="/account/manage-team" passHref>
          <Button text fluid content="Manage Team" className={classes.menuItem} />
        </Link>
      )}
      <Link href="/templates" passHref legacyBehavior>
        <a style={{ width: '100%' }}>
          <Button text fluid content="Templates" className={classes.menuItem} />
        </a>
      </Link>
      <Button
        text
        fluid
        content="Contact Us"
        onClick={handleFeedback}
        className={classes.menuItem}
      />
      <SignOutButton fluid className={classes.menuItem} />
    </div>
  )

  return (
    <header className={cx(classes.header, className)}>
      <Link className="flex items-center cursor-pointer" href="/app">
        <Image src="/logo.png" alt="App logo" width={36} height={36} />
        <h1 className={classes.appName}>My Reminders</h1>
      </Link>

      {/* Show menu if user is logged in, even if image is missing */}
      {showLogOutButton && session.status === 'authenticated' && (
        <Popup
          content={
            <>
              <div className={classes.userInfoHeader}>
                {name || 'User'} ({email || 'No email'})
              </div>
              {menuItems}
            </>
          }
          position="below"
          trigger={
            <div className={classes.avatarContainer}>
              <SafeAvatar
                image={image ? { src: image } : undefined}
                className={classes.avatarTrigger}
                title="Menu"
              />
            </div>
          }
        />
      )}
    </header>
  )
}
